
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("jQS3A", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $68a5422fcde2c4d3$export$a3c0845f856d4292);
$parcel$export(module.exports, "default", () => $68a5422fcde2c4d3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $g8Az8 = parcelRequire("g8Az8");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $68a5422fcde2c4d3$var$LazyComponent = (0, $bQWwW.lazy)(()=>(parcelRequire("d0ybF")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/ui/profilecard/index.tsx"
});
const $68a5422fcde2c4d3$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $g8Az8.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($68a5422fcde2c4d3$var$LazyComponent, props)));
var /**
 * @deprecated Use synchronous ProfileCard from index.tsx instead. Async loading
 * is already handled inside the ProfileCard component.
 */ $68a5422fcde2c4d3$export$2e2bcd8739ae039 = $68a5422fcde2c4d3$export$a3c0845f856d4292;

});
parcelRegister("g8Az8", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $57d2792abb57212f$export$c7209ce2e0d060ea);

var $7Jk3f = parcelRequire("7Jk3f");
const $57d2792abb57212f$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $7Jk3f.isLoaderError)(error)
    });

});

parcelRegister("d0ybF", function(module, exports) {

let $9785cb4f509bb580$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9785cb4f509bb580$var$load("f5PLD").then(()=>parcelRequire('7xXvm'));

});



$parcel$global.rlb("cahdx")
//# sourceMappingURL=async-old.a9e009df.js.map
